import React from "react";
import CustomerTag from "./customer-tag";

function CustomerTagList(props) {
  // `tags` is passed as `customer.data?.info`, which is undefined until the
  // customer query resolves and stays undefined when it resolves without a
  // customer — a bad id, another tenant's id, or a failed request. Reading
  // .customer_tags off that threw and took the whole page down with
  // "Cannot read properties of undefined (reading 'customer_tags')".
  // The optional chain below already guarded the map; this line did not.
  if (!props.tags?.customer_tags) return null;

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {props.tags.customer_tags?.map((tag) => {
        return (
          <CustomerTag key={tag.label} color={tag.color} label={tag.label} />
        );
      })}
    </div>
  );
}

export default CustomerTagList;
